<template>
	<div class="ms-segmented">
		<div
			v-for="tab in listTab"
			:key="tab.tabKey"
			@click="handleTabClick(tab)"
			class="ms-segmented__item"
			:class="activeTabKey === tab.tabKey ? 'ms-segmented__item--active' : ''"
		>
			<span class="whitespace-no-wrap">{{ tab.title }}</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'msSegmented',
	props: {
		/**
		 * Danh sách tab, mỗi phần tử cần có tabKey (string) và title (string)
		 */
		listTab: {
			default: () => [],
			type: Array,
		},
	},
	data() {
		return {
			activeTabKey: null,
		};
	},
	created() {
		const me = this;
		if (me.listTab.length > 0) {
			me.activeTabKey = me.listTab[0].tabKey;
		}
	},
	methods: {
		handleTabClick(tab) {
			const me = this;
			me.activeTabKey = tab.tabKey;
			me.$emit('tabActive', tab);
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msSegmented.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msSegmented.scss';
}
</style>
